import React from 'react';
import './DossierRelationsTable.scss';
import { ResponsiveTable, ResponsiveTableColumn } from '../responsive-table/ResponsiveTable';
import Button from 'react-bootstrap/Button';
import { Avatar } from '../avatar/Avatar';
import { DossierMember } from '../../models/DossierMember';
import Form from 'react-bootstrap/Form';
import { UserRelationRoleEnum } from '../../api/types';
import { Dossier } from '../../models/Dossier';

interface DossierRelationsTableProps {
  relations: DossierMember[];
  onChangeRole: (relation: DossierMember, newRole: UserRelationRoleEnum) => void;
  onDeleteRelation: (relation: DossierMember) => void;
  onEditRelation: (relation: DossierMember) => void;
  isAllowedToEdit: boolean;
}

interface IDossierRelationsTableData {
  name: JSX.Element;
  relationRole: JSX.Element|string;
  buttons: JSX.Element;
}

export function DossierRelationsTable(props: DossierRelationsTableProps): JSX.Element {
  const columns: ResponsiveTableColumn<IDossierRelationsTableData>[] = [
    { title: 'Deelnemer', objectKey: 'name', width: '22rem', disableSort: false },
    { title: 'Rol', objectKey: 'relationRole', disableSort: false },
  ];

  if (props.isAllowedToEdit) {
    columns.push({ title: '', objectKey: 'buttons', width: '25rem', disableSort: true });
  }

  const { relations } = props;

  const data: IDossierRelationsTableData[] = relations.map(relation => {
    const { user } = relation;
    const availableRoles = [UserRelationRoleEnum.client, UserRelationRoleEnum.responsibleParty, UserRelationRoleEnum.thirdParty];
    const isCaregiver = relation.role === UserRelationRoleEnum.caregiver;
    const renderEditableRole = isCaregiver ? Dossier.getRoleText(UserRelationRoleEnum.caregiver, { capitalize: true }) : (
      <Form.Control
        as="select"
        className="dossier-relations-table__role-select"
        value={relation.role}
        onChange={e => props.onChangeRole(relation, e.target.value as UserRelationRoleEnum)}
      >
        { availableRoles.map(role => <option key={role} value={role}>{Dossier.getRoleText(role, { capitalize: true }) }</option>) }
      </Form.Control>);
    const renderRelationRole = props.isAllowedToEdit ? renderEditableRole : Dossier.getRoleText(relation.role, { capitalize: true });

    return {
      name: <div className="dossier-relations-table__person">
        <Avatar user={user} className="dossier-relations-table__avatar" />
        <span>{user.name}</span>
      </div>,
      relationRole: renderRelationRole,
      buttons: <>
        <Button variant="primary" onClick={() => props.onEditRelation(relation)}>Bewerken</Button>
        <Button variant="link" className="btn-link-danger" onClick={() => props.onDeleteRelation(relation)}>Verwijderen uit dossier</Button>
      </>
    };
  });

  return (
    <>
      <ResponsiveTable<IDossierRelationsTableData> className="dossier-relations-table" columns={columns} data={data} whiteRows={true}/>
    </>
  );
}
